var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fadeHeight"}},[(_vm.show && _vm.isDesktop)?_c('div',{style:(_vm.bannerStyle)},[_c('an-banner',_vm._b({on:{"close":function($event){return _vm.onClose({ isClickEvent: true })}}},'an-banner',_vm.props,false),[_c(_vm.componentName,_vm._b({tag:"component"},'component',_vm.props,false))],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }